import { fetchData } from "./fetchData";

export const getAGMsAPI = async(jobId) => {
    const route = `/agms?jobid=${jobId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

// create many AGMs - expects array of AGMs
export const createAGMsAPI = async (agmData) => {
    const route = `/agms`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({agmData})
    }

    let response = await fetchData(route, options);

    return response;
}

// update many AGMs - expects array of AGMs
export const updateAGMsAPI = async (agmData) => {
    const route = `/agms`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({agmData})
    }

    let response = await fetchData(route, options);

    return response;
}

// delete many AGMs - expects array of AGMs
export const deleteAGMsAPI = async (agmIds) => {
    const route = `/agms`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({agmIds})
    }

    let response = await fetchData(route, options);

    return response;
}

// Get AGM template - download link
export const getAgmTemplate = async() => {
    const route = `/agms/template`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}